module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-BoldItalic_1d9be55a.8bd8035d.woff2";